import React from 'react';

import { Modal } from 'src/components/common';
import { EmployeeChangeEmailModalContent } from 'src/components/employee/EmployeeChangeEmailModalContent';
import { useModalV2 } from 'src/hooks/shared';
import type { ModalV2Props } from 'src/types/modalV2';

export type EmployeeChangeEmailModalProps = {
  userId: string;
  currentEmail: string;
  onUpdated?: () => void;
};

export const EmployeeChangeEmailModal: React.FC<ModalV2Props<EmployeeChangeEmailModalProps>> = ({
  id,
  userId,
  currentEmail,
  onUpdated,
}) => {
  const { closeModal, switchClosability } = useModalV2();

  const handleCloseModal = React.useCallback(() => {
    closeModal(id);
  }, [closeModal, id]);

  return (
    <Modal
      title="Change email"
      maxWidth={550}
      headerProps={{ sx: { pb: 0 } }}
      dialogProps={{
        fullWidth: true,
        onClose: handleCloseModal,
        open: true,
      }}
    >
      <EmployeeChangeEmailModalContent
        userId={userId}
        currentEmail={currentEmail}
        onUpdated={onUpdated}
        onCloseModal={handleCloseModal}
        switchClosability={switchClosability}
      />
    </Modal>
  );
};
